import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { DropDown, Input } from 'utils';

import styles from './gift-card.module.scss';

function GiftCardForm({ formValues, users, card, setFormValues, fetchUsers }) {
    async function handleUserChange(event, value) {
        if (!value) return;
        const userUID = value.split(' - ')[1];
        const user = await users.find(
            (user) => user.ProfileUniqeID === userUID
        );
        await setFormValues((prev) => ({ ...prev, user }));
    }

    async function handleInputChange(e, value) {
        await fetchUsers(value);
    }

    return (
        <div className={styles.form}>
            <div className={styles.form_row}>
                <p className={styles.subHeader}>User</p>
                <Autocomplete
                    className={styles.input}
                    sx={{
                        '&. MuiInputBase-root': {
                            height: {
                                xs: '32px',
                                sm: '52px'
                            },
                            fontSize: {
                                xs: '8px',
                                sm: '14px'
                            }
                        },
                        '& .MuiOutlinedInput-root': {
                            height: {
                                xs: '32px',
                                sm: '52px'
                            },
                            fontSize: {
                                xs: '8px',
                                sm: '14px'
                            },
                            borderRadius: '8px',
                            padding: '0px 8px'
                        },
                        '& .MuiAutocomplete-input': {
                            padding: 0
                        },
                        '& .MuiInputBase-input': {
                            color: '#3b4a5d !important',
                            fontFamily: 'LexendDeca'
                        },
                        '& .Mui-focused': {
                            borderColor: '#3b4a5d'
                        },
                        '& .MuiFormControl-marginNormal': {
                            margin: 0
                        }
                    }}
                    value={
                        formValues.user
                            ? formValues.user?.FullName +
                              ' - ' +
                              formValues.user?.ProfileUniqeID
                            : ''
                    }
                    onInputChange={handleInputChange}
                    options={users?.map(
                        (user) => user.FullName + ' - ' + user.ProfileUniqeID
                    )}
                    onChange={handleUserChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            margin="normal"
                            variant="outlined"
                        />
                    )}
                />
            </div>
            {card.price?.type?.toLowerCase() === 'slab' ? (
                <div  className={styles.form_row}>
                <DropDown
                    label="Denomination"
                    classname={styles.input}
                    value={formValues.denomination}
                    options={card.price.denominations.map((price) => ({
                        id: price,
                        value: price
                    }))}
                    onClick={(denomination) =>
                        setFormValues((prev) => ({
                            ...prev,
                            denomination
                        }))
                    }
                />
                </div>
            ) : (
                <div className={styles.form_row}>
                    <Input
                        label="Denomination"
                        type="tel"
                        isEditable={true}
                        inputClassName={styles.input}
                        value={formValues.denomination}
                        onChange={(e) => {
                            const { value: denomination } = e.target;
                            setFormValues((prev) => ({
                                ...prev,
                                denomination
                            }));
                        }}
                    />
                    <div className={styles.footer}>
                        <p>
                            Min: {card.price.currency.symbol}
                            {card.price.min} - Max: {card.price.currency.symbol}
                            {card.price.max}
                        </p>
                    </div>
                </div>
            )}

            <div  className={styles.form_row}>
            <DropDown
                label="Quantity"
                classname={styles.input}
                value={formValues.quantity}
                options={Array(4)
                    .fill()
                    .map((f, i) => ({
                        id: i + 1,
                        value: i + 1
                    }))}
                onClick={(quantity) =>
                    setFormValues((prev) => ({
                        ...prev,
                        quantity
                    }))
                }
            />
            </div>
            <div  className={styles.form_row}>
            <Input
                label="Comment"
                isEditable={true}
                inputClassName={styles.input}
                value={formValues.comment}
                onChange={(e) => {
                    const { value: comment } = e.target;
                    setFormValues((prev) => ({
                        ...prev,
                        comment
                    }));
                }}
            />
            </div>
        </div>
    );
}

export default GiftCardForm;
